module.exports = __webpack_public_path__ + "media/dashboard/assets/images/badge-fd5ceeee4ac3dbce19dddb19b0e7f9a2.png";